export function defaultsPlugin(flowApi) {
  return function (router) {
    router.stateRegistry.decorator('resolvePolicy', resolvePolicyDecorator);
    return {
      name: 'WixUIRouterDefaults'
    };
  };
  function resolvePolicyDecorator(state) {
    const {
      resolvePolicy
    } = state;
    const {
      isSSR
    } = flowApi.environment;
    return {
      when: (resolvePolicy == null ? void 0 : resolvePolicy.when) || 'EAGER',
      async: resolvePolicy != null && resolvePolicy.async || isSSR ? 'WAIT' : 'NOWAIT'
    };
  }
}
//# sourceMappingURL=plugin.js.map